package ru.dinarastepina.fabvocab.domain.model

data class WordEntry(
    val id: String = "",
    val word: String,
    val phonetic: String?,
    val audioUrl: String?,
    val partOfSpeech: String?,
    val definitions: List<String>,
    val exampleSentences: List<String>,
    val addedAt: Long,
    val updatedAt: Long = addedAt,
    val isDeleted: Boolean = false,
)

